export const API_CONSTANTS = {
  method: "GET",
  headers: {
    accept: "application/json",
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI3ZGMwOTkyNmYxMTZlYTY3NTFkOWNkMmZjNjM1MmViZiIsIm5iZiI6MTcyNzk3MDE4My45MjI2MzIsInN1YiI6IjY2ZmU2MTMxOTI1ZmRmOTI1YjdjODBmNSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.beKlLAyTulESb72cA3QhVZmqEHqgcRq7rokD8HGPFlg",
  },
};

export const IMG_URL = "https://image.tmdb.org/t/p/w500/";
